import { Amplify } from 'aws-amplify'

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: 'us-east-1_EbEds6tnm',
            // userPoolClientId: 'p8klfa3j978a9r4ko05sbeg7a',
            userPoolClientId: '5tudf9csk9vjdcislro9uk89th',
            loginWith: {
                email: true,
                username: true,
                oauth: {
                    domain: 'auth.vitals7.com',
                    scopes: [
                        'openid',
                        'email',
                        'profile',
                    ],
                    redirectSignIn: [
                        'http://localhost:5173/',
                        'https://sleep-apnea.vitals7.com/',
                    ],
                    redirectSignOut: [
                        'http://localhost:5173/',
                        'https://sleep-apnea.vitals7.com/',
                    ],
                    responseType: 'code',
                    providers: ['Google'],
                },
            },
            signUpVerificationMethod: 'code',
            userAttributes: {
                email: {
                    required: true,
                },
                given_name: {
                    required: true,
                },
                family_name: {
                    required: true,
                },
                birthdate: {
                    required: false,
                },
                gender: {
                    required: false,
                },
                address: {
                    required: false,
                },
                preferred_username: {
                    required: false,
                },
            },
        },
    },
})
